module.exports = __webpack_public_path__ + "static/gallery-10-08931c7842062d8f7e02022b79939692.jpg";